import { keyLabel } from '../prefs';
import type { VoiceSnapshot } from '../voice/VoiceController';

/** Microphone ready or transmitting (green icon); anything else is "off" (red icon). */
export function micIsOn(s: VoiceSnapshot): boolean {
  return s.entered && s.mic.status === 'ok' && !s.mic.muted && !s.mic.deafened;
}

/** Microphone state in words: shown as aria-label/title of the mic icon (no visible text). */
export function micStateText(s: VoiceSnapshot, pttKey: string): string {
  if (!s.entered) return 'Microfono non attivo: non sei entrato in chat vocale';
  if (s.mic.status === 'starting') return 'Microfono in avvio…';
  if (s.mic.status !== 'ok') return 'Microfono non disponibile: solo ascolto';
  if (s.mic.deafened) return 'Microfono spento: audio disattivato';
  if (s.mic.muted) return s.howl.detected ? 'Microfono spento per un fischio' : 'Microfono spento';
  if (s.mic.mode === 'ptt') return s.mic.pttPressed ? 'Microfono attivo: stai trasmettendo' : `Microfono pronto: tieni premuto ${keyLabel(pttKey)} per parlare`;
  if (s.mic.effectiveThreshold !== null && !s.mic.gateOpen) return 'Microfono pronto (sotto soglia)';
  return 'Microfono attivo';
}
